module.exports = function( THREE ){

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	THREE.DotScreenPass = function ( center, angle, scale ) {

		if ( THREE.DotScreenShader === undefined )
			console.error( "THREE.DotScreenPass relies on THREE.DotScreenShader" );

		var shader = THREE.DotScreenShader;

		this.uniforms = THREE.UniformsUtils.clone( shader.uniforms );

		if ( center !== undefined ) this.uniforms[ "center" ].value.copy( center );
		if ( angle !== undefined ) this.uniforms[ "angle" ].value = angle;
		if ( scale !== undefined ) this.uniforms[ "scale" ].value = scale;

		this.material = new THREE.ShaderMaterial( {

			uniforms: this.uniforms,
			vertexShader: shader.vertexShader,
			fragmentShader: shader.fragmentShader

		} );

		this.enabled = true;
		this.renderToScreen = false;
		this.needsSwap = true;


		this.camera = new THREE.OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );
		this.scene  = new THREE.Scene();

		this.quad = new THREE.Mesh( new THREE.PlaneBufferGeometry( 2, 2 ), null );
		this.scene.add( this.quad );

	};

	THREE.DotScreenPass.prototype = {

		render: function ( renderer, writeBuffer, readBuffer, delta ) {

			this.uniforms[ "tDiffuse" ].value = readBuffer;
			this.uniforms[ "tSize" ].value.set( readBuffer.width, readBuffer.height );

			this.quad.material = this.material;

			if ( this.renderToScreen ) {

				renderer.render( this.scene, this.camera );

			} else {

				renderer.render( this.scene, this.camera, writeBuffer, false );

			}

		}

	};

};



//////////////////
// WEBPACK FOOTER
// ./~/three-js/addons/DotScreenPass.js
// module id = 418
// module chunks = 0